import { User } from "../components/types/user";
export const getUserFromLocalStorage = () => {
  // LocalStorageからデータを取得
  const storedUser = localStorage.getItem("LoginUserOnProcessVISION");

  if (storedUser) {
    try {
      // 文字列をオブジェクトに変換
      const userObject = JSON.parse(storedUser);
      return userObject;
    } catch (error) {
      console.error("Parsing error", error);
      // パースに失敗した場合、nullや適切なデフォルト値を返す
      return null;
    }
  } else {
    // LocalStorageにユーザ情報が存在しない場合の処理
    return null; // または適切なデフォルト値
  }
};
export const setUserToLocalStorage = (loginUser: User) => {
  localStorage.setItem("LoginUserOnProcessVISION", JSON.stringify(loginUser));
};

export const removeUserFromLocalStorage = () => {
  localStorage.removeItem("LoginUserOnProcessVISION");
};
